import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { unionBy, differenceBy } from 'lodash';
import { Stack } from '@fluentui/react';
import { Divider } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getKeywordGroupsStyles } from './style/keyword-groups-style';
import { KeywordGroup } from './keyword-group';

export const KeywordGroups = ({
  allData,
  selectedData,
  onSelectChange,
}) => {
  const classes = useDefaultStyles(getKeywordGroupsStyles);
  const onToggle = useCallback((item) => {
    const selectedItem = selectedData.find(s => s.key === item.key);
    if (selectedItem) {
      onSelectChange(selectedData.filter(s => s.key !== item.key));
    } else {
      onSelectChange([...selectedData, item]);
    }
  }, [onSelectChange, selectedData]);
  const onAddAll = useCallback((groupItems) => {
    onSelectChange(unionBy(selectedData, groupItems, 'key'));
  }, [onSelectChange, selectedData]);
  const onBulkChange = useCallback((deselectItems, newSelectedItems) => {
    const selectedResult = differenceBy(selectedData, deselectItems, 'key');
    onSelectChange([...selectedResult, ...newSelectedItems]);
  }, [onSelectChange, selectedData]);

  return (
    <div className={`${classes.container} keyword-groups`}>
      <Stack
        disableShrink
        tokens={{ childrenGap: 8 }}
      >
        {allData.map((item, index) => (
          <Stack.Item key={item.Name}>
            <KeywordGroup
              groupName={item.Name}
              groupItems={item.Suggestions}
              selectedItems={selectedData}
              onToggle={onToggle}
              onAddAll={onAddAll}
              onBulkChange={onBulkChange}
            />
            { index < (allData.length - 1) && <Divider className={classes.divider} /> }
          </Stack.Item>
        ))}
      </Stack>
    </div>
  );
};

KeywordGroups.propTypes = {
  allData: PropTypes.arrayOf(PropTypes.shape({
    Suggestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  })).isRequired,
  selectedData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectChange: PropTypes.func.isRequired,
};
